import { ChangeDetectionStrategy, Component, OnInit, inject, input, output } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { TagModule } from 'primeng/tag'

import { combineLatest } from 'rxjs'

import { FlxModalModule } from '@flowx/angular-ui-toolkit'
import { ExceptionDetailsContentComponent } from '@flowx/designer/modules/process/pages/exception-details-content/exception-details-content.component'
import { ProcessExceptionsService } from '@flowx/designer/shared/services/process-exceptions.service'

@Component({
  selector: 'flx-exception-details-modal',
  imports: [FlxModalModule, TagModule, ExceptionDetailsContentComponent],
  templateUrl: './exception-details-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exception-details-modal.component.scss'],
})
export class ExceptionDetailsModalComponent implements OnInit {
  #processExceptionsService = inject(ProcessExceptionsService)
  context = toSignal(
    combineLatest({
      processException: this.#processExceptionsService.processException$,
      applicationDetails: this.#processExceptionsService.applicationDetails$,
      loading: this.#processExceptionsService.processExceptionLoading$,
    })
  )

  exceptionId = input.required<number>()
  hideModal = output()
  ngOnInit(): void {
    this.#processExceptionsService.getException(this.exceptionId())
  }
}
